<template>
    <div>
        <a v-if="isMatch" @click.prevent="jumpUrl" href="https://oss-public.allfootballapp.com/apk/allfootball-368.apk" class="btn-download" >
          Unduh Semua Sepakbola untuk pertandingan lainnya
        </a>

        <a  v-if="isArticle" @click.prevent="jumpUrl" href="https://oss-public.allfootballapp.com/apk/allfootball-368.apk"  class="btn-download" >
            {{$t('downloadForComments')}}
        </a>
    </div>
</template>

<script>
    export default {
        name: 'downloadFooter',
        data: function () {
            return {
                isMatch: false,
                isArticle: false
            };
        },
        methods: {
            jumpUrl () {
                let utilObj = require('@/util/util.js');

                if (utilObj.checkOperamini()) {
                    ga('send', 'event', 'm', 'downloadFoot', 'opreamini');
                }

                utilObj.jumpUrl();
            }
        },
        mounted () {
            if (window.location.href.indexOf('match') > -1) {
                this.isMatch = true;
            } else {
                this.isArticle = true;
            }
        }
    };
</script>
<style lang="less">
    .btn-download, a.btn-download {
        text-decoration: none !important;
        display: block;
        padding: .4rem;
        margin: 1.4rem .7rem 2.5rem .7rem;
        height: 1.8rem;
        line-height: 1.8rem;
        color: #fff;
        background: #16ac3a;
        border-radius: .2rem;
        text-align: center;
        font-size: 1rem;
    }
</style>



// WEBPACK FOOTER //
// downloadFooter.vue?65a8d956